import { render, staticRenderFns } from "./footerContact.vue?vue&type=template&id=3f6ac85c&"
import script from "./footerContact.vue?vue&type=script&lang=js&"
export * from "./footerContact.vue?vue&type=script&lang=js&"
import style0 from "./footerContact.vue?vue&type=style&index=0&scope=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports